import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import { createCoupon } from "../services/adminApi";
import CouponForm from "../components/coupons/CouponForm";

const CreateCoupon = () => {
    const navigate = useNavigate();

    const [loading, setLoading] = useState(false);

    const initialValues = {
        code: "",
        title: "",
        description: "",
        discountType: "percentage",
        discountValue: "",
        maxDiscount: "",
        minOrderAmount: "",
        usageLimit: "",
        perUserLimit: 1,
        validFrom: "",
        validUntil: "",
        status: "inactive",
        customerType: "all",
        firstOrderOnly: false,
        autoApply: false,
    };

    const handleSubmit = async (values) => {
        try {
            setLoading(true);

            await createCoupon(values);

            alert("Coupon created successfully.");

            navigate("/admin/coupons");
        } catch (err) {
            console.error(err);
            alert("Failed to create coupon.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <CouponForm
            title="Create Coupon"
            initialValues={initialValues}
            loading={loading}
            onSubmit={handleSubmit}
        />
    );
};

export default CreateCoupon;